import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDate(date: string | Date): string {
  const d = new Date(date);
  return d.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric"
  });
}

export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD"
  }).format(amount);
}

export function calculateDueDate(baseDate: Date, terms: string): Date {
  const date = new Date(baseDate);

  switch (terms) {
    case "Net 0":
    case "Due on Receipt":
      return date;
    case "Net 15":
      date.setDate(date.getDate() + 15);
      return date;
    case "Net 30":
      date.setDate(date.getDate() + 30);
      return date;
    case "Net 45":
      date.setDate(date.getDate() + 45);
      return date;
    case "Net 60":
      date.setDate(date.getDate() + 60);
      return date;
    default:
      return date;
  }
}

// Common payment terms options
export const PAYMENT_TERMS_OPTIONS = [
  { label: "Due on Receipt", value: "Net 0" },
  { label: "Net 15", value: "Net 15" },
  { label: "Net 30", value: "Net 30" },
  { label: "Net 45", value: "Net 45" },
  { label: "Net 60", value: "Net 60" },
  { label: "Custom", value: "custom" }
];

// Check if the URL is a Vercel blob URL
export const isVercelBlobUrl = (url: string) => {
  return url.includes("blob.vercel-storage.com");
};
